import React from "react";
import { Modal, Button } from "react-bootstrap";

const ExpenseDetailModal = ({ show, onHide, expense }) => {
  if (!expense) return null;

  // Support both:
  // New format: attachment = []
  // Old format: attachment = {}
  const attachments = Array.isArray(expense.attachment)
    ? expense.attachment
    : expense.attachment?.url
      ? [expense.attachment]
      : [];

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Expense Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>Name:</strong>{" "}
          {expense.id_user ? expense.id_user.name : "N/A"}
        </p>

        <p>
          <strong>Hub:</strong> {expense.id_hub ? expense.id_hub.name : "N/A"}
        </p>

        <p>
          <strong>Vehicle:</strong>{" "}
          {expense.id_vehicle ? expense.id_vehicle.numberplate : "-"}
        </p>

        <p>
          <strong>Transaction Type:</strong> {expense.transactionType || "-"}
        </p>

        <p>
          <strong>Category:</strong>{" "}
          {expense.id_expenseCategory ? expense.id_expenseCategory.name : "N/A"}
        </p>

        <p>
          <strong>Amount:</strong> {expense.amount || "-"}
        </p>

        <p>
          <strong>Account Number:</strong>{" "}
          {expense.id_user?.bank_details?.account_number || "-"}
        </p>

        <p>
          <strong>Bank Name:</strong>{" "}
          {expense.id_user?.bank_details?.bank_name || "-"}
        </p>

        <p>
          <strong>Branch Name:</strong>{" "}
          {expense.id_user?.bank_details?.branch_name || "-"}
        </p>

        <p>
          <strong>IFSC Code:</strong>{" "}
          {expense.id_user?.bank_details?.ifsc_code || "-"}
        </p>

        <p>
          <strong>Account Holder Name:</strong>{" "}
          {expense.id_user?.bank_details?.account_holder_name || "-"}
        </p>

        <p>
          <strong>Created By:</strong>{" "}
          {expense.createdBy ? (
            <>
              <span>
                <strong>Name:</strong> {expense.createdBy.user_email}
              </span>

              <span>, </span>

              <span>
                <strong>Role:</strong> {expense.createdBy.user_role}
              </span>
            </>
          ) : (
            "-"
          )}
        </p>

        <p>
          <strong>Comments:</strong> {expense.comments || "-"}
        </p>

        {/* ===================================================== */}
        {/* Attachments */}
        {/* ===================================================== */}

        <div className="mt-4">
          <h6 className="mb-3">
            <strong>Attachments</strong>
          </h6>

          {attachments.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {attachments.map((file, index) => {
                const fileName =
                  file.fileName || file.public_id || `Attachment ${index + 1}`;

                return (
                  <div
                    key={`${file.public_id || file.url}-${index}`}
                    className="border rounded p-3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "15px",
                    }}
                  >
                    {/* File Name */}
                    <div
                      style={{
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      <strong
                        style={{
                          wordBreak: "break-word",
                        }}
                      >
                        {fileName}
                      </strong>
                    </div>

                    {/* View + Download */}
                    <div
                      className="d-flex gap-2"
                      style={{
                        flexShrink: 0,
                      }}
                    >
                      {/* View */}
                      <Button
                        variant="outline-primary"
                        size="sm"
                        as="a"
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </Button>

                      {/* Download */}
                      <Button
                        variant="outline-success"
                        size="sm"
                        as="a"
                        href={file.url}
                        download={fileName}
                      >
                        Download
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-muted">No attachments available.</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExpenseDetailModal;
